import { Lock } from "./async";
import { removeElement } from "./array";
export class AbstractListenableEvent {
    get hasListeners() {
        return (this.mListeners.length !== 0);
    }
    constructor(pOwner) {
        this.mOwner = pOwner;
        this.mListeners = new Array();
        this.mLockQueue = null;
        this.mListenersLocked = false;
    }
    addListener(pListener) {
        if (pListener == null)
            return;
        if (this.mListenersLocked)
            this.addToLockQueue(false, pListener);
        else
            this.mListeners.push(pListener);
    }
    removeListener(pListener) {
        if (pListener == null)
            return;
        if (this.mListenersLocked)
            this.addToLockQueue(true, pListener);
        else
            removeElement(this.mListeners, pListener);
    }
    addToLockQueue(pRemove, pListener) {
        if (this.mLockQueue == null)
            this.mLockQueue = new Array();
        this.mLockQueue.push({ remove: pRemove, listener: pListener });
    }
    processLockQueue() {
        if (this.mLockQueue == null)
            return;
        for (const tEntry of this.mLockQueue) {
            if (tEntry.remove)
                this.removeListener(tEntry.listener);
            else
                this.addListener(tEntry.listener);
        }
        this.mLockQueue = null;
    }
}
/**
* Synchronous listenable event.
*/
export class ListenableEvent extends AbstractListenableEvent {
    trigger(pParameter) {
        if (this.mListeners.length === 0)
            return;
        this.mListenersLocked = true; //lock listeners array
        try {
            for (const tListener of this.mListeners)
                tListener(pParameter, this.mOwner);
        }
        finally {
            this.mListenersLocked = false;
            this.processLockQueue();
        }
    }
}
/**
* Asynchronous listenable event.
*/
export class AsyncListenableEvent extends AbstractListenableEvent {
    constructor(pOwner) {
        super(pOwner);
        this.mTriggerLock = new Lock();
    }
    async trigger(pParameter) {
        if (this.mListeners.length === 0)
            return;
        const tLockContext = await this.mTriggerLock.acquireLock();
        try {
            this.mListenersLocked = true; //lock listeners array
            for (const tListener of this.mListeners)
                await tListener(pParameter, this.mOwner);
        }
        finally {
            this.mListenersLocked = false;
            this.processLockQueue();
            tLockContext.unlock();
        }
    }
}
